import {ErrorViewProps} from './types'
import {ExclamationIcon} from 'components/Icon'
import React from 'react'
const ErrorView: React.FC<ErrorViewProps> = (props: ErrorViewProps): React.ReactElement => {
    const {errorMessage} = props
    return (
        <div>
            <ExclamationIcon />
            <span data-testid='errorMessage'>{errorMessage}.</span>
        </div>
    )
}
export default ErrorView
